import { useCallback, useState } from "react";

/**
 * Provides a `scrollTo(elementId)` function that smoothly scrolls a DOM
 * element into view. `attemptCount` increments on every call so consumers
 * can react to new requests.
 */
export function useScrollToElement() {
  const [attemptCount, setAttemptCount] = useState(0);

  const scrollTo = useCallback((elementId: string) => {
    setAttemptCount((n) => n + 1);
    requestAnimationFrame(() => {
      document.getElementById(elementId)?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }, []);

  return { attemptCount, scrollTo };
}
